import { MessageService, type Chat, type Message } from '@/shared/api';
import { useFetchComposable } from '@/shared/lib';

const useMessageContext = () => {
  const { send: getContext } = useFetchComposable(
    ({ chatId, messageId }: { chatId: Chat['id']; messageId: Message['id'] }) =>
      MessageService.getMessageContext({ path: { id: chatId, messageId } }),
  );

  return { getContext };
};

export { useMessageContext };
